import { Box, Typography, Button, LinearProgress, RadioGroup, FormControlLabel, Radio, useTheme, IconButton, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faChevronUp, faChevronDown} from '@fortawesome/free-solid-svg-icons';

//lj
function generateArray(x) {
  const result = [];
  let remainingTotal = 100;
  for (let i = 0; i < x; i++) {
    const randomNumber = Math.floor(Math.random() * remainingTotal);
    result.push(randomNumber);
    remainingTotal -= randomNumber;
  }
  result.push(remainingTotal);
  return result.sort((a, b) => b - a);
}

const Preview = ({ survey }) => {

    const {_id, creation, question, choices, nbVotes, options} = survey
    const {validate, numberOfChoices} = options

    const [localVotes, setLocalVotes] = useState({})

    // CHECK VOTE
    function hasVotedFor(choiceId){
        return false
    }

    function hasUniqueVotedFor(){

        return choices.map((c, idx) => {
            return false
        }).some(s => s)
    }

    const handleMultipleVote = (idxChoice, entryId) => {
      setLocalVotes(s => ({...s, [idxChoice] : entryId}))
    }

    const handleUniqueVote = (idxChoice, entryId) => {

      if(hasUniqueVotedFor())
        return

        if(localVotes[idxChoice]){
          delete localVotes[idxChoice]
          setLocalVotes(s => ({...localVotes}))
        }
        else
          setLocalVotes(s => ({...s, [idxChoice] : entryId}))
  }

  const isValidQuizz = () => Object.keys(localVotes).length === numberOfChoices

    if(choices[0].entries.length === 1)
      return (
          <Box>
           {/* <Typography variant="mediaH1">Sondage</Typography>*/}
           <Box sx={{padding:'1rem'}}>
            <Typography variant="body1" gutterBottom>
              Question : {question}
            </Typography>
          </Box>
            {/*<Typography variant="mediaH2" component="div">{question}</Typography>*/}

            <SingleQuestionQuizz quizz={survey} isSelectedChoice={(choice, idx) => localVotes[idx] === choice.entries[0].id} localVotes={localVotes} hasVoted={hasUniqueVotedFor} handleVote={handleUniqueVote} isValidQuizz={isValidQuizz}/>
          </Box>
        );

    if(choices[0].entries.length > 1)
      return (
        <Box>
            {/*<Typography variant="mediaH1">Sondage</Typography>*/}
            {/*<Typography variant="mediaH2" component="div">{question}</Typography>*/}
            <Box sx={{padding:'1rem'}}>
            <Typography variant="body1" gutterBottom>
              Question : {question}
            </Typography>
          </Box>
            <MultipleQuestionQuizz quizz={survey} hasVoted={() => hasVotedFor(0)} isSelectedChoice={(idx, entryId) => localVotes[idx] === entryId} handleVote={handleMultipleVote} isValidQuizz={isValidQuizz} />
          </Box>
        );
}

const SingleQuestionQuizz = ({ quizz, isSelectedChoice, hasVoted, handleVote, isValidQuizz, validateQuizz }) => {
  const { _id, creation, question, choices, nbVotes, options } = quizz;
  const {validate, numberOfChoices } = options

  const useStyles = makeStyles((theme) => ({
    choiceContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
      padding: '6px',
      borderRadius: '15px',
      maxWidth: '600px',
      border: `1px solid ${theme.palette.media.lightgrey}`,
      position: 'relative',
    },
    selectedChoice: {
      border: `1px solid ${theme.palette.media.darkblue}`,
    },
    correctChoice: {
      border: `1px solid ${theme.palette.media.green}`,
      color: theme.palette.media.green,
    },
    incorrectChoice: {
      border: `1px solid ${theme.palette.media.red}`,
      color: theme.palette.media.red,
    },
    disabledRadio: {
      pointerEvents: 'none',
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    enabledRadio: {},
    checkIcon: {
      position: 'absolute',
      top: '50%',
      right: 0,
      transform: 'translate(50%, -50%)',
      fontSize: '24px',
      backgroundColor: '#FFFFFF',
      padding: '4px',
      borderRadius: '50%',
    },
  }));

  const classes = useStyles();

  return (
    <>
    <Box sx={{ marginTop: '16px', pl: 2 }}>
      <RadioGroup name={_id}>
        {choices.map((choice, idx) => (
          <Box
            key={idx}
            className={`${classes.choiceContainer} ${
              isSelectedChoice(choice, idx) ? classes.selectedChoice : ''}`}
          >
            <FormControlLabel
              checked={isSelectedChoice(choice, idx)}
              value={choice.entries[0].id}
              control={
                <Radio
                  color='quizzdarkblue'
                  style={{ marginRight: '8px' }}
                  onClick={(e) => handleVote(idx, e.target.value)}
                />
              }
              label={choice.entries[0].name}
              className={classes.enabledRadio}
            />

            {isSelectedChoice(choice, idx) && (
              <FontAwesomeIcon
                icon={faCheckCircle}
                className={classes.checkIcon}
                style={{
                  color: 'quizzdarkblue'
                }}
              />
            )}
          </Box>
        ))}
      </RadioGroup>
    </Box>

    {validate && <ValidateButton isValid={isValidQuizz} handleValidate={validateQuizz} />}
    </>
  );
};

const MultipleQuestionQuizz = ({ quizz, isSelectedChoice, hasVoted, handleVote, isValidQuizz, validateQuizz }) => {

  const { _id, creation, question, choices, nbVotes, options } = quizz;
  const { validate, numberOfChoices } = options

  const useStyles = makeStyles((theme) => ({
    choiceContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
      padding: '6px',
      borderRadius: '15px',
      maxWidth: '600px',
      border: `1px solid ${theme.palette.media.lightgrey}`,
      position: 'relative',
    },
    selectedChoice: {
      border: `1px solid ${theme.palette.media.darkblue}`,
    },
    correctChoice: {
      border: `1px solid ${theme.palette.media.green}`,
      color: theme.palette.media.green,
    },
    incorrectChoice: {
      border: `1px solid ${theme.palette.media.red}`,
      color: theme.palette.media.red,
    },
    disabledRadio: {
      pointerEvents: 'none',
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    enabledRadio: {},
    checkIcon: {
      position: 'absolute',
      top: '50%',
      right: 0,
      transform: 'translate(50%, -50%)',
      fontSize: '24px',
      backgroundColor: '#FFFFFF',
      padding: '4px',
      borderRadius: '50%',
    },
  }));

  const classes = useStyles();

  return <>
  <Box
    sx={{
      marginTop: '16px',
      pl : 2
    }}
  >
        {choices.map((choice, idx) => (
            <Box mb={3} sx={{display : 'flex', maxWidth : '600px'}}>
                <EntrySelect choice={choice} handleChoice={(entryId) => handleVote(idx, entryId)}/>
            </Box>
            
        ))}
  </Box>
  {validate && <ValidateButton isValid={isValidQuizz} handleValidate={validateQuizz} />}
</>

}

const ValidateButton = ( {isValid}) => {

  return <Button sx={{width:'fit-content'}} variant="contained" color="primary" disabled={!isValid()} >Valider mon vote</Button>
}

const EntrySelect = ({ choice, handleChoice }) => {
  const [open, setOpen] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState('');

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleSelect = (entryId) => {
    setSelectedEntry(entryId);
    handleChoice(entryId)
    setOpen(false);
  };

  const theme = useTheme();
  return (
    <Box sx={{ width: '100%', mb : 1 }}>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          marginBottom: '20px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          maxWidth: '600px',
          borderRadius: '15px 15px 15px 15px',
          backgroundColor: 'grey',
        }}
      >
        <Typography
          component="div"
          variant="mediaH3"
          sx={{
            backgroundColor: 'white',
            height: '50px',
            width: 'calc(100% - 60px)',
            borderRadius: '15px 0px 0px 15px',
            pl : 2,
            display: 'flex',
          alignItems: 'center', // Centrer le contenu verticalement
            '&:hover': {
              cursor : 'pointer',
              '& + button': {
                backgroundColor: `${theme.palette.media.lightgrey}`, // Modifier la couleur de fond de l'IconButton lors du survol de la Typography
              },
            },
          }}
          onClick={handleToggle}
        >
          {choice.label}
        </Typography>
        <IconButton
          sx={{
            position: 'absolute',
            right: 0,
            height: '50px',
            width: '40px',
            backgroundColor: 'white',
            borderRadius: '0px 15px 15px 0px', // Ajouter un rayon de bordure aux angles haut droit et bas droit
            padding: '4px',
            fontSize: '15px', // Réduire la taille de l'icône
            '&:hover': {
              backgroundColor: `${theme.palette.media.lightgrey}`, // Modifier la couleur de fond de l'IconButton lors du survol de la Typography
            },
          }}
          onClick={handleToggle}
        >
          <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
        </IconButton>

        {open && (
        <Box
          sx={{
            position: 'absolute',
            top: 'calc(100% + 2px)',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: '4px',
            zIndex: 1,
          }}
        >
          {choice.entries.map((entry) => (
            <MenuItem key={entry.id} onClick={() => handleSelect(entry.id)}>
              {entry.name}
            </MenuItem>
          ))}
        </Box>
      )}
      </Box>

      {selectedEntry && (
        <Typography
          variant="mediaH3"
          component={"div"}
          sx={{
            backgroundColor: 'media.lightgrey',
            borderRadius: '4px',
            marginTop: '2px',
            padding: '4px',
            pl : 2
          }}
        >
          {choice.entries.find((entry) => entry.id === selectedEntry)?.name}
        </Typography>
      )}
    </Box>
  );
};

export default Preview